import { SubmissionRankingEntryService } from './SubmissionRankingEntryService';

export default {
	'services.ranking.submissionRankingEntryService': {
		class: SubmissionRankingEntryService,
		deps: [{ $ref: 'services.challengeSubmissionService' }],
	},
};
